import { render, staticRenderFns } from "./ViewDiagram.vue?vue&type=template&id=3f6a0c16&scoped=true&"
import script from "./ViewDiagram.vue?vue&type=script&lang=js&"
export * from "./ViewDiagram.vue?vue&type=script&lang=js&"
import style0 from "./ViewDiagram.vue?vue&type=style&index=0&id=3f6a0c16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a0c16",
  null
  
)

export default component.exports